import React, { useState } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { ModalActionsComponent, PasslyButton, PasslyTextField } from '@app/components';
import { FormControl } from '@material-ui/core';
import { onPressEnterModal } from '@app/helpers';

interface IReceivedData {
    onCancelClick: Function;
    confirmCallback: Function;
}

const CONFIRMATION_PHRASE = 'Export';

const ConfirmationPopupBodyComponent = (props: IReceivedData) => {
    const { translation } = useTypedTranslation();
    const { onCancelClick, confirmCallback } = props;

    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [confirmationPhrase, setConfirmationPhrase] = useState<string>('');
    const onConfirmationPhraseChange = (e: any) => {
        const value = e.target.value.trim();

        setErrorMessage('');
        setConfirmationPhrase(value);
    };
    const onConfirm = (e: any) => {
        e.preventDefault();
        e.stopPropagation();

        if (confirmationPhrase === CONFIRMATION_PHRASE) {
            confirmCallback();
        } else {
            setErrorMessage(translation('EXPORT_VAULTS_CONFIRM_ERROR'));
        }
    };

    return (
        <>
            <div className='confirmExportModal' onKeyPress={onPressEnterModal(onConfirm)}>
                <div className='confirmExportModal__body'>
                    <form className='confirmExportModal__form'>
                        <FormControl className=''>
                            <div
                                className='confirmExportModal__form--text'
                                dangerouslySetInnerHTML={{ __html: translation('EXPORT_VAULTS_CONFIRM_DESCRIPTION') }}
                            />
                            <PasslyTextField
                                name='confirmationText'
                                value={confirmationPhrase}
                                onChange={onConfirmationPhraseChange}
                                id='confirmation-text'
                                error={!!errorMessage}
                                helperText={errorMessage}
                                required
                                fullWidth
                            />
                        </FormControl>
                    </form>
                </div>
            </div>
            <ModalActionsComponent
                primaryBtn={translation('CONFIRM')}
                secondaryBtn={translation('CANCEL')}
                onClickPrimary={onConfirm}
                onClickSecondary={onCancelClick}
            />
        </>
    );
};

export default ConfirmationPopupBodyComponent;
